import { contentFor } from "../data/toolContent.js";
import { Link } from "react-router-dom";
import NhanTram from "./NhanTram.jsx";
import { tramCuaCongCu } from "../data/lo-trinh.js";
import { CAU_HOI_CONG_CU } from "../data/toolCauHoi.js";

/**
 * Phần tĩnh của trang công cụ: tiêu đề, đoạn mở đầu, câu hỏi thường gặp.
 *
 * Component này được render sẵn thành HTML lúc build nên KHÔNG được phụ thuộc
 * vào ngày giờ, Math.random hay bất cứ thứ gì khác nhau giữa lúc build và lúc
 * chạy — nếu khác, React sẽ báo lệch khi hydrate.
 */
export default function ToolIntro({ tool }) {
  const content = contentFor(tool);
  return (
    <div className="tool-heading">
      <p className="breadcrumb">
        <Link to="/cong-cu">Công cụ</Link> / {tool.title}
      </p>
      <NhanTram tram={tramCuaCongCu(tool.slug)} trang="cong-cu" />
      <h1>{tool.title}</h1>
      {/* Gọn: một câu hỏi công cụ trả lời. Đoạn giới thiệu đầy đủ vẫn nằm trong
          HTML (cho Google và người cần đọc), chỉ thu vào mục mở thêm. */}
      <p className="tc-hoi">{CAU_HOI_CONG_CU[tool.slug] || content.intro}</p>
      {CAU_HOI_CONG_CU[tool.slug] && content.intro && (
        <details className="tc-gioi-thieu">
          <summary>Công cụ này giúp gì?</summary>
          <p>{content.intro}</p>
        </details>
      )}
    </div>
  );
}

export function ToolFaq({ tool }) {
  const { faq } = contentFor(tool);
  if (!faq || faq.length === 0) return null;
  return (
    <section className="khoi hoi-dap">
      <h2>Câu hỏi thường gặp</h2>
      {faq.map((f) => (
        <div key={f.q} className="mot-hoi">
          <h3>{f.q}</h3>
          <p>{f.a}</p>
        </div>
      ))}
    </section>
  );
}
